module.exports = __webpack_public_path__ + "static/fonts/iconfont.4b7f050b.woff";